import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";

import Map2 from "../map/map";
import * as sisMapActions from "store/modules/rds_sisMap";
import * as Service from "services/RestAPI";
import "./DefaultContents.scss";
const CATEGORY_LIST = [
	{ target: "population", label: "인구", icon: "sis/images/main/icon_1.png" },
	{ target: "transportation", label: "교통", icon: "sis/images/main/icon_2.png" },
	{ target: "living", label: "생활", icon: "sis/images/main/icon_3.png" },
	{ target: "welfare", label: "복지", icon: "sis/images/main/icon_4.png" },
	{ target: "sanitary", label: "보건", icon: "sis/images/main/icon_5.png" },
	{ target: "culture", label: "문화", icon: "sis/images/main/icon_6.png" },
	{ target: "safety", label: "안전", icon: "sis/images/main/icon_7.png" },
	{ target: "realEstate", label: "부동산", icon: "sis/images/main/icon_8.png" },
];

const LINKED_INFO_LIST = [
	{
		title: "교통",
		url: "https://www.gjtic.go.kr/",
		pcImage: "sis/images/main/linked_traffic.png",
		mobileImage: "sis/images/main/linked_traffic.png",
	},
	{
		title: "부동산",
		url: "https://seereal.lh.or.kr/SeerealMAP/seerealCommon/mainPage.do",
		pcImage: "sis/images/main/linked_realestate.png",
		mobileImage: "sis/images/main/linked_realestate.png",
	},
	{
		title: "문화",
		url: "https://tour.jeonnam-gwangju.go.kr",
		pcImage: "sis/images/main/linked_culture.png",
		mobileImage: "sis/images/main/linked_culture.png",
	},
	{
		title: "3차원지도",
		url: "https://map.vworld.kr/map/maps.do",
		pcImage: "sis/images/main/linked_3dmap.png",
		mobileImage: "sis/images/main/linked_3dmap.png",
	},
	{
		title: "관광빅데이터분석",
		url: "https://bigdata.jeonnam-gwangju.go.kr/tour/index.html#/tour/mapservice?1",
		pcImage: "sis/images/main/linked_tourbigdata.png",
		mobileImage: "sis/images/main/linked_tourbigdata.png",
	},
];

const STATS_YEAR_DATA = {
	"2025": {
		latest: true,
		fileName: "2025 통계연보.zip",
		downloadUrl: "/sis/reference/2025 통계연보.zip",
	},
	"2024": {
		latest: true,
		fileName: "2024 통계연보.zip",
		downloadUrl: "/sis/reference/2024 통계연보.zip",
	},
	"2023": {
		latest: false,
		fileName: "2023 통계연보.zip",
		downloadUrl: "/sis/reference/2023 통계연보.zip",
	},
	"2022": {
		latest: false,
		fileName: "2022 통계연보.zip",
		downloadUrl: "/sis/reference/2022 통계연보.zip",
	},
};

const BANNER_LIST = [
	{ title: "전남광주통합특별시", url: "https://jeonnam-gwangju.go.kr/" },
	{ title: "비짓전남광주", url: "https://tour.jeonnam-gwangju.go.kr/" },
	{ title: "관광빅데이터분석", url: "https://bigdata.jeonnam-gwangju.go.kr/tour/index.html#/tour/mapservice?1/" },
	{ title: "SEE:REAL", url: "https://seereal.lh.or.kr/" },
	{ title: "3차원지도", url: "https://map.vworld.kr/map/maps.do" },
];

class DefaultContents extends Component {
	state = {
		weatherList: [],
		activeWeather: 0,
		nowDate: new Date(),

		noticeList: [],
		currentNoticeIndex: 0,

		sggList: [],
		umdList: [],
		riList: [],
		selectedSgg: "0",
		selectedUmd: "0",
		selectedRi: "0",
		sanChk: false,
		bobn: "",
		bubn: "",

		constructionYN: null,
		activeLinkedTitle: "교통",
		statsYear: "2025",

		bannerIndex: 0,
		bannerPerView: 5,
		bannerItemWidth: 0,
	};

	noticeTimer = null;
	bannerSliderRef = React.createRef();

	componentDidMount() {
		this._getNoticeList();
		this.callUserConfig();

		/* HTML 시안의 주소 검색 셀렉트에 기존 API 데이터를 연결합니다. */
		this._getSggList();

		this.updateBannerLayout();
		window.addEventListener("resize", this.updateBannerLayout);
	}

	componentWillUnmount() {
		this.stopNoticeSlider();
		window.removeEventListener("resize", this.updateBannerLayout);
	}

	// 사용자 IP에 따라 건설사업 메뉴 노출 여부 확인
    callUserConfig = () => {
		fetch("/api/com/user/config")
			.then((response) => {
				if (!response.ok) {
					throw new Error("사용자 설정 조회에 실패했습니다.");
				}
				return response.json();
			})
			.then((data) => {
				const allowedIpList = [
					"211.253.121.18",
					"211.253.121.34",
					"127.0.0.1",
					"10.30.0.63",
				];

                    this.setState({
					constructionYN: allowedIpList.includes(data.javaIp) ? "N" : "N",
				});
			})
			.catch((error) => {
				console.error(error);
				this.setState({ constructionYN: "N" });
			});
	};

	// 공지사항 API 조회
	_getNoticeList = async () => {
		try {
			const res = await Service.getNoticeList();
			const noticeList = Array.isArray(res.data) ? res.data.slice(0, 4) : [];

			this.setState(
				{
					noticeList,
					currentNoticeIndex: 0,
				},
				() => {
					if (noticeList.length > 1) {
						this.startNoticeSlider();
					}
				}
			);
		} catch (error) {
			console.error("공지사항 조회 실패:", error);
			this.setState({ noticeList: [], currentNoticeIndex: 0 });
		}
	};

	startNoticeSlider = () => {
		this.stopNoticeSlider();

		this.noticeTimer = window.setInterval(() => {
			this.setState((prevState) => {
				const count = prevState.noticeList.length;
				if (count <= 1) return null;

				return {
					currentNoticeIndex: (prevState.currentNoticeIndex + 1) % count,
				};
			});
		}, 3500);
	};

	stopNoticeSlider = () => {
		if (this.noticeTimer) {
			window.clearInterval(this.noticeTimer);
			this.noticeTimer = null;
		}
	};

	// 공지사항 상세 이동: event DOM 구조에 의존하지 않고 공지 번호를 직접 전달
	handleNotice = (noticeNo) => {
		if (!noticeNo) return;
		this.props.history.push(`/notice/${noticeNo}`);
	};

	// 날씨 리스트 가져오기: 기존 메서드 보존
	_getWeatherList = async () => {
		try {
			const res = await Service.getWeatherList();
			this.setState({ weatherList: res.data || [] });
		} catch (error) {
			console.error("날씨정보 조회 실패:", error);
		}
	};

	// 시군구 목록
	_getSggList = async () => {
		try {
			const res = await Service.getSggList();
			this.setState({ sggList: res.data || [] });
		} catch (error) {
			console.error("시군구 조회 실패:", error);
		}
	};

	// 읍면동 목록
	_getUmdList = async (regnCode) => {
		if (!regnCode || regnCode === "0") {
			this.setState({ umdList: [], riList: [] });
			return;
		}

		try {
			const res = await Service.getUmdList(regnCode);
			this.setState({ umdList: res.data || [], riList: [] });
		} catch (error) {
			console.error("읍면동 조회 실패:", error);
		}
	};

	// 리 목록: 현재 HTML 시안에는 표시하지 않지만 기존 기능을 위해 보존
	_getRiList = async (regnCode) => {
		if (!regnCode || regnCode === "0") {
			this.setState({ riList: [] });
			return;
		}

		try {
			const res = await Service.getRiList(regnCode);
			this.setState({ riList: res.data || [] });
		} catch (error) {
			console.error("리 조회 실패:", error);
		}
	};

	handleSggChange = (e) => {
		const selectedSgg = e.target.value;

			this.setState({
			selectedSgg,
			selectedUmd: "0",
			selectedRi: "0",
			umdList: [],
			riList: [],
		});

		this._getUmdList(selectedSgg);
	};

	handleUmdChange = (e) => {
		const selectedUmd = e.target.value;

		this.setState({
			selectedUmd,
			selectedRi: "0",
			riList: [],
			});

		this._getRiList(selectedUmd);
	};

	handleRiChange = (e) => {
		this.setState({ selectedRi: e.target.value });
	};

	// 본번/부번 입력 및 산 여부 변경
	changeInput = (e) => {
		const { name, value, type, checked } = e.target;

		this.setState({
			[name]: type === "checkbox" ? checked : value,
		});
	};

	handleLandTypeChange = (e) => {
		this.setState({ sanChk: e.target.value === "2" });
	};

	// 부동산 지번 검색
	handleSubmit = (e) => {
		if (e && typeof e.preventDefault === "function") {
			e.preventDefault();
		}

		const { SisMapActions } = this.props;
		const {
			selectedSgg,
			selectedUmd,
			selectedRi,
			sanChk,
			bobn,
			bubn,
			sggList,
			umdList,
		} = this.state;

		if (selectedSgg === "0") {
			alert("구를 선택해 주세요.");
			return;
		}

		if (selectedUmd === "0") {
			alert("동을 선택해 주세요.");
			return;
		}

		if (!bobn.trim()) {
			alert("본번을 입력해 주세요.");
			return;
		}

		const selectedSggItem = sggList.find(
			(item) => String(item.regnCode) === String(selectedSgg)
		);
		const selectedUmdItem = umdList.find(
			(item) => String(item.regnCode) === String(selectedUmd)
		);

		const sggNm = selectedSggItem ? selectedSggItem.sggNm : "";
		const emdNm = selectedUmdItem ? selectedUmdItem.umdNm : "";

		/*
		 * 기존 로직과 동일하게 읍면동 코드 뒤에 리 코드 00을 붙입니다.
		 * 리 단위 검색을 다시 사용할 경우 selectedRi 값으로 교체하면 됩니다.
		 */
		let pnu = String(selectedUmd);
			pnu += "00";
		pnu += sanChk ? "2" : "1";
		pnu += lpad(bobn.trim(), 4, "0");
		pnu += lpad((bubn || "").trim(), 4, "0");

		SisMapActions.searchPnu({
			pnu,
			sggNm,
			emdNm,
			ri: selectedRi,
			bobn,
			bubn,
		});

		this.props.history.push("/mapMain");
	};

	// 분야별 지도 카테고리 이동
	mapToCategory = (target) => {
		const { SisMapActions } = this.props;

		const categoryNameMap = {
			population: "인구",
			transportation: "교통",
			living: "생활",
			welfare: "복지",
			sanitary: "보건",
			culture: "문화",
			safety: "안전",
			realEstate: "부동산",
			construction: "건설사업",
		};

		SisMapActions.mainCategory(target);
		this._setVisitInfo(document.referrer, categoryNameMap[target] || "");
		this.props.history.push("/mapMain");
	};

	handleCategoryClick = (e, target) => {
		e.preventDefault();
		this.mapToCategory(target);
	};

	// 연계 사이트 새 창 이동: 기존 메서드 보존
	homePageMove = (target) => {
		const linkedItem = LINKED_INFO_LIST.find((item) => item.title === target);

		if (linkedItem && linkedItem.url) {
			window.open(linkedItem.url, "_blank", "noopener,noreferrer");
		}
	};

	_setVisitInfo = (ref, category) => {
		const query = new URLSearchParams({
			ref: ref || "",
			visitCategory: category || "",
		});

		fetch(`/api/setVisit?${query.toString()}`, {
			method: "GET",
			credentials: "same-origin",
		}).catch((error) => {
			console.error("방문정보 저장 실패:", error);
		});
	};

	// 날씨정보 왼쪽 이동: 기존 메서드 보존
	handleWeatherMoveLeft = () => {
		const { weatherList, activeWeather } = this.state;
		const target =
			activeWeather - 1 < 0 ? weatherList.length - 1 : activeWeather - 1;

		this.setState({ activeWeather: target });
	};

	// 날씨정보 오른쪽 이동: 기존 메서드 보존
	handleWeatherMoveRight = () => {
		const { weatherList, activeWeather } = this.state;
		const target =
			activeWeather + 1 > weatherList.length - 1 ? 0 : activeWeather + 1;

		this.setState({ activeWeather: target });
	};

	handleKeyDown = (e) => {
		if (e.key === "Enter") {
			this.handleSubmit(e);
		}
	};

	selectLinkedInfo = (title) => {
		this.setState({ activeLinkedTitle: title });
	};

	handleStatsYearChange = (e) => {
		this.setState({ statsYear: e.target.value });
	};

	getBannerPerView = () => {
		const width = window.innerWidth;

		if (width <= 480) return 1;
		if (width <= 767) return 2;
		if (width <= 1024) return 3;
		if (width <= 1280) return 4;
		return 5;
	};

	updateBannerLayout = () => {
		const slider = this.bannerSliderRef.current;
		const bannerPerView = Math.min(this.getBannerPerView(), BANNER_LIST.length);
		const bannerItemWidth = slider ? slider.clientWidth / bannerPerView : 0;
		const maxIndex = Math.max(BANNER_LIST.length - bannerPerView, 0);

		this.setState((prevState) => ({
			bannerPerView,
			bannerItemWidth,
			bannerIndex: Math.min(prevState.bannerIndex, maxIndex),
		}));
	};

	handleBannerPrev = () => {
		this.setState((prevState) => {
			const maxIndex = Math.max(
				BANNER_LIST.length - prevState.bannerPerView,
				0
			);

			if (maxIndex === 0) return null;

			return {
				bannerIndex:
					prevState.bannerIndex <= 0
						? maxIndex
						: prevState.bannerIndex - 1,
			};
		});
	};

	handleBannerNext = () => {
		this.setState((prevState) => {
			const maxIndex = Math.max(
				BANNER_LIST.length - prevState.bannerPerView,
				0
			);

			if (maxIndex === 0) return null;

			return {
				bannerIndex:
					prevState.bannerIndex >= maxIndex
						? 0
						: prevState.bannerIndex + 1,
			};
		});
	};

	toggleMapSearch = (collapsed) => {
		this.setState({ isMapSearchCollapsed: collapsed });
	};
	// 통계연보 전체 ZIP 다운로드
	basicDown = (year) => {
		const fileName = `${year} 통계연보.zip`;
		const fileUrl = `/sis/reference/${fileName}`;

		const link = document.createElement("a");

		link.href = fileUrl;
		link.setAttribute("download", fileName);
		link.style.display = "none";

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	render() {
		const {
			noticeList,
			currentNoticeIndex,
			sggList,
			umdList,
			selectedSgg,
			selectedUmd,
			sanChk,
			bobn,
			bubn,
			constructionYN,
			isMapSearchCollapsed,
			activeLinkedTitle,
			statsYear,
			bannerIndex,
			bannerPerView,
			bannerItemWidth,
		} = this.state;

		const categoryList =
			constructionYN === "Y"
				? [
					...CATEGORY_LIST,
					{
						target: "construction",
						label: "건설사업",
						icon: "/images/icon_9.png",
					},
				]
				: CATEGORY_LIST;

		const activeLinked =
			LINKED_INFO_LIST.find((item) => item.title === activeLinkedTitle) ||
			LINKED_INFO_LIST[0];

		const selectedStats = STATS_YEAR_DATA[statsYear] || STATS_YEAR_DATA["2025"];
		const statsTitle = `${statsYear}년 광주 통계연보`;

		const currentNotice = noticeList.length
			? noticeList[currentNoticeIndex % noticeList.length]
			: null;

		const bannerMaxIndex = Math.max(
			BANNER_LIST.length - bannerPerView,
			0
		);

		return (
			<div className="site-wrap default-contents-page">
				{ }
				<main>
					<section className="field-section layout" id="field-map">
						<h2 className="section-title field-title">
							분야별
							<br className="pc-only" />
							지도
						</h2>

						<ul className="field-list" aria-label="분야별 지도 바로가기">
							{categoryList.map((item) => (
								<li key={item.target}>
									<a
										href="/mapMain"
										onClick={(e) => this.handleCategoryClick(e, item.target)}
									>
										<img src={item.icon} alt="" />
										<span>{item.label}</span>
									</a>
								</li>
							))}
						</ul>
					</section>

					<section className="map-section layout" aria-label="부동산 정보조회">
						<div
							className={`map-view${isMapSearchCollapsed ? " is-search-collapsed" : ""
								}`}
						>
							<div className="map-real" aria-label="전남광주 지도">
								<Map2 className="sisMapWrap2" />
						</div>

							<button
								type="button"
								className="map-search-open"
								onClick={() => this.toggleMapSearch(false)}
							>
								부동산 정보조회
							</button>

							{/* <form className="map-search" onSubmit={this.handleSubmit}>
								<div className="map-search__head">
									<h3>부동산 정보조회</h3>

									<div className="map-search__head-util">
										<a
											href="/mapMain"
											className="mini-link"
											onClick={(e) =>
												this.handleCategoryClick(e, "realEstate")
											}
										>
											메뉴이동 &gt;
										</a>

										<button
											type="button"
											className="map-search__toggle"
											aria-expanded={!isMapSearchCollapsed}
											onClick={() => this.toggleMapSearch(true)}
										>
											접기
										</button>
									</div>
								</div>
									
								<div className="map-search__body">
									<fieldset>
										<legend>주소</legend>

										<div className="select-grid select-grid--address">
											<label>
												<span className="sr-only">구명</span>
												<select
													id="sgg"
													value={selectedSgg}
													onChange={this.handleSggChange}
												>
													<option value="0">구명</option>
													{sggList.map((item) => (
														<option
															key={item.regnCode}
															value={item.regnCode}
														>
													{item.sggNm}
													</option>
													))}
												</select>
											</label>

											<label>
												<span className="sr-only">동명</span>
												<select
													id="umd"
													value={selectedUmd}
													onChange={this.handleUmdChange}
												>
													<option value="0">동명</option>
													{umdList.map((item) => (
														<option
															key={item.regnCode}
															value={item.regnCode}
														>
													{item.umdNm}
													</option>
													))}
												</select>
											</label>

											<label>
												<span className="sr-only">일반 또는 산</span>
												<select
													value={sanChk ? "2" : "1"}
													onChange={this.handleLandTypeChange}
												>
													<option value="1">일반</option>
													<option value="2">산</option>
												</select>
											</label>
										</div>
									</fieldset>

									<fieldset>
										<legend>지번</legend>

										<div className="select-grid select-grid--parcel">
											<label>
												<span className="sr-only">본번</span>
												<input
													id="bobn"
													type="text"
													name="bobn"
													value={bobn}
													maxLength="4"
													inputMode="numeric"
													placeholder="본번"
													onChange={this.changeInput}
													onKeyDown={this.handleKeyDown}
												/>
											</label>

											<span className="dash" aria-hidden="true">
												-
											</span>

											<label>
												<span className="sr-only">부번</span>
												<input
													id="bubn"
													type="text"
													name="bubn"
													value={bubn}
													maxLength="4"
													inputMode="numeric"
													placeholder="부번"
													onChange={this.changeInput}
													onKeyDown={this.handleKeyDown}
												/>
											</label>
							</div>
									</fieldset>

									<button type="submit" className="search-btn">
									검색
									</button>
								</div>
							</form> */}
							</div>
					</section>

					<section className="info-section layout">
						<div className="linked-card" id="linked-info">
							<h2 className="section-title">분야별 사이트맵</h2>

							<div className="tab-list" role="tablist" aria-label="사이트맵 구분">
								{LINKED_INFO_LIST.map((item) => {
									const isActive = item.title === activeLinkedTitle;

											return (
										<button
											key={item.title}
											className={isActive ? "active" : ""}
											type="button"
											role="tab"
											aria-selected={isActive}
											onClick={() => this.selectLinkedInfo(item.title)}
										>
											{item.title}
										</button>
											);
										})}
							</div>

							<a
								className="linked-preview"
								href={activeLinked.url}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={`${activeLinked.title} 사이트맵 자세히 보기`}
							>
								<picture>
									<source
										media="(max-width: 767px)"
										srcSet={activeLinked.mobileImage}
									/>
									<img
										src={activeLinked.pcImage}
										alt={`${activeLinked.title} 메인 화면`}
									/>
								</picture>

								<span className="linked-preview__dim" aria-hidden="true" />
								<span className="linked-preview__button">자세히보기</span>
							</a>
									</div>

						<div
							className="stats-card stats-card--ebook stats-card--single"
							id="stats"
						>
							<div>
								<h2 className="section-title">통계연보</h2>
									</div>

							<div className="stats-sub-title">
								<p className="stats-card__lead">
									연도를 선택해 PDF를 확인하세요.
								</p>

								<label className="stats-filter">
									<span className="sr-only">통계연보 연도 선택</span>
									<select
										value={statsYear}
										aria-label="통계연보 연도 선택"
										onChange={this.handleStatsYearChange}
									>
										{Object.keys(STATS_YEAR_DATA)
											.sort((a, b) => Number(b) - Number(a))
											.map((year) => (
												<option key={year} value={year}>
													{year}년
												</option>
											))}
									</select>
								</label>
								</div>

							<article className="stats-book-panel" aria-live="polite">
								<a
									className="stats-book-cover stats-book-cover--large"
									href={selectedStats.ebookUrl}
									target="_blank"
									rel="noopener noreferrer"
									aria-label={`${statsTitle} 보기`}
								>
									<span
										className="stats-book-cover__spine"
										aria-hidden="true"
									/>

									{selectedStats.latest && (
										<span className="stats-book-cover__badge">NEW</span>
									)}

									<span className="stats-book-cover__year">{statsYear}</span>
									<span className="stats-book-cover__title">
										광주
										<br />
										통계연보
									</span>
								</a>

								<div className="stats-book-info stats-book-info--single">
									<span className="stats-book-label">선택 연도</span>
									<strong>{statsTitle}</strong>

									<div className="stats-book-actions">
										<button
											type="button"
											className="stats-book-btn stats-book-btn--download"
											onClick={() => this.basicDown(statsYear)}
										>
											통계연보 다운로드
										</button>
								</div>
							</div>
							</article>
								</div>
					</section>

					<section
						className="notice-row layout"
						id="notice"
						aria-label="공지사항"
						onMouseEnter={this.stopNoticeSlider}
						onMouseLeave={this.startNoticeSlider}
						onFocus={this.stopNoticeSlider}
						onBlur={this.startNoticeSlider}
					>
						<NavLink to="/notice" className="notice-title">
							<span>N</span>
							<strong>공지사항</strong>
								</NavLink>

						<div className="notice-slide" aria-live="polite">
							{currentNotice ? (
								<button
									type="button"
									className="notice-text"
									onClick={() => this.handleNotice(currentNotice.ntNo)}
								>
									{currentNotice.ntTitle}
								</button>
							) : (
								<span className="notice-text">등록된 공지사항이 없습니다.</span>
							)}
									</div>

						{currentNotice && (
							<time dateTime={currentNotice.ntDt}>{currentNotice.ntDt}</time>
						)}

						<NavLink
							to="/notice"
							className="notice-more"
							aria-label="공지사항 더보기"
						/>
					</section>
				</main>

				

				<div id="tree" className="tree" style={{ display: "none" }} />
				
			</div>
		);
	}
}

function lpad(str, padLen, padStr) {
	if (padStr.length > padLen) {
		// console.log("오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다");
		return str;
	}

	let result = String(str || "");
	const fill = String(padStr || "");

	while (result.length < padLen) {
		result = fill + result;
	}

	return result.length >= padLen ? result.substring(0, padLen) : result;
}

export default compose(
	withRouter,
	connect(
		(state) => ({
			sis: state.category,
		}),
		(dispatch) => ({
			SisMapActions: bindActionCreators(sisMapActions, dispatch),
		})
	)
)(DefaultContents);
